// extracted by mini-css-extract-plugin
module.exports = {"itemWrap":"newsletter-signup-items_itemWrap__TmxAR","item":"newsletter-signup-items_item__WgICX","description":"newsletter-signup-items_description__dfyXE"};